import React, { Component, PropTypes } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { connect } from "react-redux";

class CastleLoader extends Component {
  render() {
    let refreshStatus = this.props.waiting ? "loading" : "hide";
    return (
      <div
        className="mainLoader"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
        }}
        hidden={!this.props.waiting} //TO DO is this part working? displays when inverted but not on refresh
      >
        <CircularProgress
          style={{
            marginLeft: "50%",
            marginTop: "50vh",
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    waiting: state.ui.waiting,
  };
};

var ConnectedCastleLoader = connect(mapStateToProps)(CastleLoader);

export default ConnectedCastleLoader;
